// append 'origin' to bypass CDN due to being blocked by CORS
const appendOriginToSubdomain = (url) => {
  const urlArray = url.split('.');
  urlArray[0] = urlArray[0].concat('-origin');
  return urlArray.join('.');
};

export default appendOriginToSubdomain;
